/**
 * WhatsApp iletişim kanalı — tek kaynak.
 * Numara güncellenirse SADECE burası değişir.
 */
export const WHATSAPP_PHONE_E164 = '905536838375'; // +90 553 683 83 75

export function buildWhatsAppUrl(message) {
  return `https://wa.me/${WHATSAPP_PHONE_E164}?text=${encodeURIComponent(message)}`;
}
